module.exports = __webpack_public_path__ + "img/worker.620a6127.svg";